<template>
  <NCard v-bind="mergedAttrs" class="c-card">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </NCard>
</template>

<script lang="ts" setup>
import { merge } from 'lodash-es'
import type { CardProps } from 'naive-ui'
import { NCard } from 'naive-ui'
import { useAttrs } from 'vue'

const attrs: CardProps = useAttrs()

const defaultAttrs: CardProps = {
  size: 'small',
}

const mergedAttrs: CardProps = merge(defaultAttrs, attrs)

defineSlots()
</script>
